<template>
	<div>
		<Card>
			<transition name="fade">
			    <Row v-if="mainTable.sarchCommissionShow"
			        :gutter="16">
			        <Col span="24">
			        <search-card :form="mainTable.searchCommissionForm"
			            :table-load-event="getCommissionTableRecords"
			            :table-search="mainTable.tableSearch" />
			        </Col>
			    </Row>
			</transition>
			<Row :gutter="16">
				<Col span="24">
				<div class="global-tool-bar">
					<div class="left-bar">
						<span class="title">佣金修改记录表</span>
					</div>
					<div class="right-bar">
					    <Button type="primary"
					        size="small"
					        class="btns"
					        shape="circle"
					        icon="ios-search"
					        @click="mainTable.sarchCommissionShow = !mainTable.sarchCommissionShow">搜索</Button>
					</div>
				</div>
				</Col>
			</Row>
			
			<Row :gutter="16">
				<Col span="24">
					<stand-pagination-table :columns="mainTable.columns"
						:data="mainTable.data"
						:loading="mainTable.loading"
						:table-search="mainTable.tableSearch"
						:table-load-event="getCommissionTableRecords" />
				</Col>
			</Row>
			
		</Card>
	</div>
</template>

<script>
import search from '@/libs/search';
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import { getSeedFarmCommissionRecordList } from '@/api/modules/finance-management/commission';
export default{
    name: 'seedFarmCommissionList',
    components: { StandPaginationTable, SearchCard },
    data(){
        return{
            mainTable:{
                columns:[
                    { title: "苗场编号", key: "seedFarmCode", align: "center" },
                    { title: "苗场名称", key: "seedFarmName", align: "center" },
                    { title: "修改前佣金比例(%)", key: "commissionRateBefore", align: "center" },
                    { title: "修改后佣金比例(%)", key: "commissionRate", align: "center" },
                    { title: "修改人账号", key: "opUserName", align: "center" },
                    { title: "修改人", key: "opUserPerson", align: "center" },
                    { title: "修改时间", key: "updateTime", align: "center", render: (h, params) => dateTimeRender(h, params.row.updateTime) }
                ],
                data: [],
                loading:false,
                searchCommissionForm: [
					    { label: '苗场', type: 'Input', value: '', name: 'seedFarmName', sql: 'like' },
					    { label: '修改账号', type: 'Input', value: '', name: 'opUserName', sql: 'like' },
					    { label: '修改时间', type: 'Daterange', value: [], name: 'updateTime', sql: 'dateBetween' }
                ],
                sarchCommissionShow:false,
                tableSearch:search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getCommissionTableRecords();
    },
    methods:{
        getCommissionTableRecords(reset = false){
            this.mainTable.loading = true;
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
				
            getSeedFarmCommissionRecordList(this.mainTable.tableSearch).then(res =>{
                if (res.code === 0) {
					    this.mainTable.data = res.data.records;
					    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
                this.mainTable.loading = false;
            }).catch(()=>{
                this.mainTable.loading = false;
            });
        }
    }
};
</script>

<style>
</style>